import React, { useState } from 'react';
import { Avatar, Dialog, DialogContent, DialogTitle, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { aws_base_path } from '../../../config/config';

export default function ChefBusinessCard({ chef }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Avatar 
        onClick={handleOpen} 
        data-testid="chef-avatar-button"
        sx={{ cursor: 'pointer' }}
      >
        {chef.firstName[0]}
      </Avatar>

      <Dialog 
        open={open} 
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        data-testid="chef-business-card-dialog"
      >
        <DialogTitle>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Profile</span>
            <IconButton onClick={handleClose} size="small" data-testid="close-dialog-button">
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 24, alignItems: 'center' }}>
            <Avatar 
              src={aws_base_path + chef.profilePic} 
              alt={`${chef.firstName} ${chef.lastName}`}
              sx={{ width: 120, height: 120 }}
            />
            
            <div style={{ width: '100%' }}>
              <Typography variant="h5" gutterBottom align="center">
                {chef.firstName} {chef.lastName}
              </Typography>
              
              {/* {chef.yearsOfExperience && (
                <Typography variant="body1" color="text.secondary" gutterBottom align="center">
                  {chef.yearsOfExperience} years of experience
                </Typography>
              )} */}
              
              {chef.selfIntroduction && (
                <div style={{ marginTop: 16 }}>
                  <Typography variant="h6" gutterBottom>
                    About me
                  </Typography>
                  <Typography variant="body2" color="text.secondary" style={{ whiteSpace: 'pre-wrap' }}>
                    {chef.selfIntroduction}
                  </Typography>
                </div>
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
